var render = function render(){var _vm=this,_c=_vm._self._c;return _c('environment-template',{attrs:{"local-air-quality":_vm.localAirQuality,"usual-environment":_vm.usualEnvironment,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }